<template>
  <div class="mb-6 xhtml-string" :class="readOnly ? 'w-full' : 'w-11/12'" v-html="description" />
</template>

<script>
export default {
  name: 'Schema Description',
  props: {
    description: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
    published: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
